import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=5efcf71c&scoped=true&"
import script from "@/scripts/QA/QuestionList/index.js?vue&type=script&lang=js&"
export * from "@/scripts/QA/QuestionList/index.js?vue&type=script&lang=js&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=5efcf71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efcf71c",
  null
  
)

export default component.exports